export default {
	name: "draw-winner-modal",
	props: ["heading", "modalId", "showModal", "campaignId"],
	emits: ["okClicked", "winningSubmissionSelected"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			submission: {},
			loading: false,
			showErrorMessage: false
		};
	},
	methods: {
		drawWinner(){
			this.loading = true;
			this.showErrorMessage = false;
			competitionService.drawWinner(this.campaignId).then(
				response => {
					if(response.status === 200){
						if(response.data.result === null) {
							this.showErrorMessage = true;
						}
						else {
							this.submission = response.data.result;
							this.showErrorMessage = false;
						}
					}
					this.loading = false;
				}
			);
		},
		onModalCloseClick(){
			this.$emit("okClicked");
		},
		onViewSubmissionClick(){
			this.$emit("winningSubmissionSelected", this.submission);
		}
	},
	mounted: function () {
		
	},
	watch:{
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal({backdrop: 'static', keyboard: false});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		campaignId: {
			handler: function (){
				if(this.campaignId !== null && this.campaignId !== undefined){
					this.drawWinner();
				}
			}
		}
	}
};